export default {
    title: "Verifica dell'indirizzo",
    header: "@:views.address.verified.title",
    message: "Grazie per aver verificato il tuo indirizzo. Ora puoi scegliere questo come indirizzo di spedizione quando effettui un ordine.",
}